<app-admin-form [title]="'SupplierInterface instellingen'" [object]="settings" [withSettingsSelector]="true"
  (settingsChanged)="settings=$event">

  @for (supplier of adminSettingsService.getAdminSetting(settings,'Suppliers').Value; track $index) {
  <app-admin-supplier-input
    [label]="adminSettingsService.getAdminSetting(settings, supplier + '_LeverancierNr').Description"
    [(model)]="adminSettingsService.getAdminSetting(settings, supplier + '_LeverancierNr').Value"
    [noneSelectionLabel]="'Geen leverancier geselecteerd.'">
  </app-admin-supplier-input>
  }

  <app-admin-cancel-save-button
    [saveAction]="adminSettingsService.saveSettingsSupplierInterface(settings)"></app-admin-cancel-save-button>
</app-admin-form>